import { render, staticRenderFns } from "./BoxPlot.vue?vue&type=template&id=d0eea32e&scoped=true&"
import script from "./BoxPlot.vue?vue&type=script&lang=js&"
export * from "./BoxPlot.vue?vue&type=script&lang=js&"
import style0 from "./BoxPlot.vue?vue&type=style&index=0&id=d0eea32e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0eea32e",
  null
  
)

export default component.exports